<div class="content-breadcrumb div-breadcrumb">
  <em class="fa fa-users icon-breadcrumb"></em>
  <span class="text-breadcrumb">Dependentes Especiais</span>
</div>

<div class="container-fluid">
  <div class="row mt-4">
    <div class="col">
        <form class="form-inline" (ngSubmit)="filterForm.form.valid && buscarDependente()" #filterForm="ngForm">
          <div class="input-group w-25">
            <input class="form-control" type="text" placeholder="Buscar..." id="valueFilter" name="valueFilter" [(ngModel)]="valueFilter">
            <button class="btn btn-primary"><i class="fa fa-search"></i></button></div>
        </form>
    </div>
    <div class="col-auto">
        <button type="button" class="btn btn-primary float-right" (click)="novoDependenteModal(contentModalNovo)">
          <i class="fa fa-plus"></i> &nbsp; Dependente
        </button>
    </div>
  </div>
  <app-card  titleCard="Lista de dependetes especiais cadastrados">
    <div class="table-responsive">
      <table class="table table-bordered table-hover text-center text-table">
          <thead>
              <tr class="table-active">
                  <th style="width: 100px">Cód</th>
                  <th>Nome</th>
                  <th style="width: 200px">CPF Responsável</th>
                  <th style="width: 80px">Ações</th>
              </tr>
          </thead>
          <tbody>
            <ng-template ngFor let-dependentes [ngForOf]="listaDependentes">
              <tr>
                <th scope="row">{{ dependentes.id }}</th>
                <th>{{ dependentes.nomeDependente }}</th>
                <th>{{ dependentes.cpfResponsavel }}</th>
                <th>
                  <a data-toggle="tooltip" title="Deletar dependente">
                    <em class="fa fa-trash icon-table" (click)="deletarModal(contentModalDeletar, dependentes.id)"></em>
                  </a>
                </th>
              </tr>
            </ng-template>
          </tbody>
        </table>
    </div>
  </app-card>

  <!-- MODAL PARA DELETAR DEPENDENTE-->
  <ng-template #contentModalDeletar let-closed="close" let-dismiss="dismiss">
    <form #frmProcedure="ngForm" autocomplete="off" (ngSubmit)="deletarDependente(frmProcedure)">
        <div class="modal-header">
          <div class="container row me-0 pe-0">
            <div class="col">
              <h4 class="modal-title">Apagar dependente</h4>
            </div>
            <div class="col-auto">
              <div class="d-flex justify-content-end me-0 pe-0">
                <button type="button" class="close" aria-label="Close" (click)="dismiss('click')">
                    <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-body">
            <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-2">
                <label class="label-control">Você tem certeza, ao apagar esse dependente especial ele não terá mais consultas por ter mais de 18 anos.</label>
              </div>
            </div>
        </div>

        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="dismiss('click')"> <i class="fa fa-times" aria-hidden="true"></i>&nbsp; Cancelar</button>
            <button type="submit" class="btn btn-danger"><i class="fa fa-check" aria-hidden="true"></i>&nbsp; Confirmar</button>
        </div>
    </form>
</ng-template>

 <!-- MODAL PARA CRIAR UM NOVO DEPENDENTE-->
<ng-template #contentModalNovo let-closed="close" let-dismiss="dismiss">
  <form #frmProcedure="ngForm" autocomplete="off" (ngSubmit)="salvarDependente(frmProcedure)">
      <div class="modal-header">
        <div class="container row me-0 pe-0">
          <div class="col">
            <h4 class="modal-title">Novo dependente</h4>
          </div>
          <div class="col-auto">
            <div class="d-flex justify-content-center me-0 pe-0">
              <button type="button" class="close" aria-label="Close" (click)="dismiss('click')">
                  <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-body">
          <div class="row">
              <div class="col-2 col-sm-2 col-md-2 col-lg-2 mb-2">
                <input class="form-control" type="text" mask="0000000" placeholder="Matrícula" name="matricula"
                [(ngModel)]="matricula" #matriculaText="ngModel" (keyup)="buscarDependenteEspecialPorMatricula($event.target.value)">
                  <app-message [control]="matriculaText" error="required" text="Matrícula do titular é obrigatório!"></app-message>
              </div>

              <div class="col-5 col-sm-5 col-md-5 col-lg-5 mb-2">
                <input class="form-control" type="text" placeholder="Nome do colaborador" name="nomeColaborador" [disabled]="true" [(ngModel)]="nomeColaborador">
              </div>

              <div class="col-5 col-sm-5 col-md-5 col-lg-5 mb-2">
                <ngx-select [items]="listaBeneficiariosCombo" optionValueField="nome" optionTextField="nome" placeholder="Selecione o Beneficiário"
                  [disabled]="disabledBeneficiarios" noResultsFound="Nenhum resultado encontrado"
                  name="beneficiado" required [(ngModel)]="beneficiado" #beneficiadoSelect="ngModel">
                </ngx-select>
                <app-message [control]="beneficiadoSelect" error="required" text="Campo obrigatório!"></app-message>
              </div>
          </div>
      </div>
      <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="dismiss('click')"> <i class="fa fa-times" aria-hidden="true"></i>&nbsp; Cancelar</button>
          <button type="submit" class="btn btn-primary"><i class="fa fa-check" aria-hidden="true"></i>&nbsp; Confirmar</button>
      </div>
  </form>
</ng-template>
</div>
